/* tslint:disable */
/* tslint:disable */
/**
 * ClearFlask Admin API
 * ClearFlask API documentation.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
// eslint-disable-next-line no-unused-vars
import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface Hotjar
 */
export interface Hotjar {
    /**
     * 
     * @type {string}
     * @memberof Hotjar
     */
    trackingCode: string;
}

export function HotjarFromJSON(json: any): Hotjar {
    return {
        'trackingCode': json['trackingCode'],
    };
}

export function HotjarToJSON(value?: Hotjar): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'trackingCode': value.trackingCode,
    };
}


